__turbopack_context__.v({
  "root": "zUDI-G_root",
});
